import { render, staticRenderFns } from "./fact_raw.vue?vue&type=template&id=e01fbf38&scoped=true&"
import script from "./fact_raw.vue?vue&type=script&lang=ts&"
export * from "./fact_raw.vue?vue&type=script&lang=ts&"
import style0 from "./fact_raw.vue?vue&type=style&index=0&id=e01fbf38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01fbf38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
